import { render } from "./LawsuitReceipt.vue?vue&type=template&id=abe99b98&scoped=true"
import script from "./LawsuitReceipt.vue?vue&type=script&lang=js"
export * from "./LawsuitReceipt.vue?vue&type=script&lang=js"

import "./LawsuitReceipt.vue?vue&type=style&index=0&id=abe99b98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abe99b98"]])

export default __exports__